export const chatQueryKeys = {
  all: () => ["chat"] as const,
  list: () => [...chatQueryKeys.all(), "list"] as const,
  archivedList: () => [...chatQueryKeys.all(), "archived-list"] as const,
  detail: (chatID: string) =>
    [...chatQueryKeys.all(), "detail", chatID] as const,
};
